{
  "name": "@jun133/kitty",
  "version": "4.0.7",
  "description": "Agent",
  "license": "MIT",
  "keywords": [
    "kitty",
    "agent",
    "automation",
    "runtime",
    "harness"
  ],
  "bin": {
    "kitty": "dist/cli.js"
  },
  "files": [
    "dist/*.js",
    "dist/*.mjs",
    "dist/*.map",
    "dist/web/**",
    "README.md",
    "scripts/postinstall.cjs"
  ],
  "publishConfig": {
    "access": "public"
  },
  "engines": {
    "node": ">=22.13.0"
  },
  "scripts": {
    "build": "node scripts/build.mjs",
    "check": "npm run typecheck && npm run build && npm run check:package",
    "check:package": "node scripts/verify-package.mjs",
    "dev": "npm run build --silent && node dist/cli.js",
    "test:build": "node -e \"require('node:fs').rmSync('.test-build', { recursive: true, force: true })\" && tsc -p tsconfig.tests.json",
    "test:core": "npm run test:build && node scripts/run-tests.mjs core",
    "test:eval": "npm run test:build && node scripts/run-tests.mjs evaluation",
    "eval:local": "npm run test:build && node .test-build/scripts/run-evaluation.js local",
    "eval:production": "npm run test:build && node .test-build/scripts/run-evaluation.js production",
    "verify": "npm test",
    "typecheck": "tsc --noEmit",
    "postinstall": "node scripts/postinstall.cjs",
    "prepack": "npm run build",
    "test": "npm run check && npm run test:core"
  },
  "dependencies": {
    "@openilink/openilink-sdk-node": "^0.6.0",
    "bootstrap": "^5.3.8",
    "bootstrap-icons": "^1.13.1",
    "chalk": "^5.6.2",
    "commander": "^14.0.1",
    "diff": "^8.0.2",
    "docx": "^9.7.1",
    "dotenv": "^17.2.3",
    "execa": "^9.6.0",
    "fast-glob": "^3.3.3",
    "figlet": "^1.11.0",
    "ink": "^7.1.0",
    "mammoth": "^1.12.0",
    "marked": "^15.0.7",
    "openai": "^6.4.0",
    "pdfjs-dist": "^6.1.200",
    "qrcode": "^1.5.4",
    "react": "^19.2.7",
    "silk-wasm": "^3.7.1",
    "string-width": "^8.2.1",
    "wrap-ansi": "^10.0.0",
    "ws": "^8.21.0"
  },
  "devDependencies": {
    "@types/node": "^24.5.2",
    "@types/qrcode": "^1.5.6",
    "@types/react": "^19.2.17",
    "@types/ws": "^8.18.1",
    "tsup": "^8.5.0",
    "typescript": "^5.9.2"
  }
}
